/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Logout_WordsInputs */

const en_us2_search_field_logout_words = /** @type {(inputs: Search_Field_Logout_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sign out logout log out`)
};

const pt_br2_search_field_logout_words = /** @type {(inputs: Search_Field_Logout_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sair logout deslogar`)
};

const es_419_search_field_logout_words = /** @type {(inputs: Search_Field_Logout_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cerrar sesion salir logout`)
};

const pt_pt2_search_field_logout_words = /** @type {(inputs: Search_Field_Logout_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sair terminar sessao logout`)
};

const fr_fr2_search_field_logout_words = /** @type {(inputs: Search_Field_Logout_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deconnecter deconnexion sortir quitter`)
};

const de_de2_search_field_logout_words = /** @type {(inputs: Search_Field_Logout_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abmelden logout ausloggen`)
};

const it_it2_search_field_logout_words = /** @type {(inputs: Search_Field_Logout_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esci logout disconnetti`)
};

/**
* | output |
* | --- |
* | "sign out logout log out" |
*
* @param {Search_Field_Logout_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_logout_words = /** @type {((inputs?: Search_Field_Logout_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Logout_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_logout_words(inputs)
	if (locale === "es-419") return es_419_search_field_logout_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_logout_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_logout_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_logout_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_logout_words(inputs)
	return en_us2_search_field_logout_words(inputs)
});
export { search_field_logout_words as "search.field_logout_words" }